/**
 * 生成服务
 */

import { request } from "../request";
import type { VideoGenerationResult } from "@xmiles/holopix-types";

/**
 * 生成视频服务
 */
export const getVideoGenerationStatus = ({ message }: { message: string }) => {
  return request<VideoGenerationResult>({
    url: "/pino_service_api/aiApi/api/generateVideo",
    method: "post",
    data: {
      data: {
        message
      }
    },
    isAuth: true,
    isEncryption: true
  });
};

/**
 * 生成火山云视频服务
 *
 */
export function getAivideoGenerateStatus({ message }: Record<string, string>) {
  return request<VideoGenerationResult>({
    url: "/pino_service_api/aiApi/api/generateVolceVideo",
    method: "post",
    data: { data: { message } },
    isAuth: true,
    isEncryption: true
  });
}
